
import { Component, Ref, Vue } from 'vue-property-decorator'
import LoginPage from '@/components/templates/LoginPage.vue'
import LoginMethods from '@/utils/TemporaryLoginMethods'

/**
 * 仮ユーザ用ログインページ
 */
@Component({
  components: {
    LoginPage,
  },
})
export default class TemporaryUserLogin extends Vue {
  /** ログインページ */
  @Ref()
  loginPage!: LoginPage

  /**
   * ログインボタン押下時の処理
   */
  private async eventClickLoginButton(): Promise<void> {
    const result = await this.submitLogin()
    if (result) {
      // ログイン成功時はメールアドレス登録画面に遷移
      await this.$router.push('/activate/regist')
    } else {
      alert('ログインに失敗しました。')
    }
  }

  /**
   * ログインAPI
   *
   * @returns ログイン結果
   */
  private async submitLogin(): Promise<boolean | null> {
    return await LoginMethods.login(this.loginPage.loginId(), this.loginPage.password())
  }
}
